import { useEffect, useRef } from "react";
import ImgixLoader from "@utils/images/ImgixLoader";
import isServer from "@utils/is-server";

function ProductZoomImage({ imgUrl, index, setMostVisiblePictureIndex }) {
  const imageRef = useRef();
  const intersectionObserverTimeout = useRef();
  const intersectionObserver = useRef();

  useEffect(() => {
    const imageRefCopy = imageRef.current;

    const onElementIntersecting = (entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        setMostVisiblePictureIndex(index);
      }
    };

    function setIntersectionObserver() {
      if (intersectionObserverTimeout.current) clearTimeout(intersectionObserverTimeout.current);

      const timeout = setTimeout(() => {
        if (isServer()) return;

        if (intersectionObserver.current) intersectionObserver.current.unobserve(imageRef.current);

        const { innerHeight } = window;
        const imageHeight = imageRef.current.getBoundingClientRect().height;
        // intersecting is true when a picture occupies at least half of the screen height
        const ratioThreshold = Math.min(innerHeight / 2 / imageHeight, 1);

        const options = {
          root: null,
          rootMargin: "0px",
          threshold: ratioThreshold,
        };

        intersectionObserver.current = new IntersectionObserver(onElementIntersecting, options);
        if (imageRef.current) intersectionObserver.current.observe(imageRef.current);
      }, 100);

      intersectionObserverTimeout.current = timeout;
    }

    const resizeObserver = new ResizeObserver(() => {
      setIntersectionObserver();
    });

    if (imageRefCopy) resizeObserver.observe(imageRefCopy);

    return () => {
      if (imageRefCopy) resizeObserver.unobserve(imageRefCopy);
    };
  }, [imageRef, setMostVisiblePictureIndex, index]);

  return (
    <div
      className="product-zoom-image-container"
      id={`product-zoom-image-container-${index}`}
      ref={imageRef}
    >
      {/* nextJs Image results on a flickering effect on scroll even with loading="eager"
      so that we use a simple img */}
      {/* eslint-disable @next/next/no-img-element */}
      <img
        src={ImgixLoader({ src: imgUrl, width: 2048 })}
        alt=""
        className="product-zoom-image"
      />
    </div>
  );
}

export default ProductZoomImage;
